@import '../../vars.css';

.footer {
    width: 100%;
    box-sizing: border-box;
    transition:
        box-shadow 0.2s ease,
        background 0.2s ease;
}

.sticky {
    background: var(--modal-footer-background);
    position: sticky;
}

.highlighted {
    background: var(--modal-footer-highlight-background);
    box-shadow: var(--modal-footer-highlight-box-shadow);
}
